import styled from 'styled-components';

export const LoadingSpinnerBackground = styled.div.attrs({
  className: 'loading-spinner-background'
})`
  background-color: ${(props) =>
    props.isRelative ? 'inherit' : 'rgba(255, 255, 255, 0.5)'};

  /* We want the background to take up the whole space */
  position: ${(props) => (props.isRelative ? 'relative' : 'absolute')};
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;

export const LoadingSpinner = styled.div.attrs({
  className: 'loading-spinner'
})`
  /* 
   * We want the spinner to be in the middle of the background
   */
  position: ${(props) => (props.isRelative ? 'relative' : 'absolute')};
  top: 50%;
  left: 50%;
  margin-left: -40px; // This is half of the width (80px)
  margin-top: ${(props) =>
    props.isRelative ? '0' : '-40px'}; // This is half of the height (80px)

  /*
   * Inspired by w3school.com: 
   * https://www.w3schools.com/howto/tryit.asp?filename=tryhow_css_loader
   */
  border: 8px solid
    rgba(
      ${({ color }) => (color ? redFromHex(color) : 255)},
      ${({ color }) => (color ? greenFromHex(color) : 255)},
      ${({ color }) => (color ? blueFromHex(color) : 255)},
      0.35
    );
  border-radius: 50%;
  border-top: 8px solid ${({ color }) => color};
  width: 80px;
  height: 80px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
  display: block;

  /* Safari */
  @-webkit-keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

/*
 * Inspiration taken from:
 * https://gist.github.com/danieliser/b4b24c9f772066bcf0a6
 */

const redFromHex = (hex) => {
  hex = hex.replace('#', '');
  return parseInt(hex.substring(0, 2), 16);
};

const greenFromHex = (hex) => {
  hex = hex.replace('#', '');
  return parseInt(hex.substring(2, 4), 16);
};

const blueFromHex = (hex) => {
  hex = hex.replace('#', '');
  return parseInt(hex.substring(4, 6), 16);
};



// WEBPACK FOOTER //
// ./src/components/common/Loading/LoadingSpinnerComponent.style.js